import { cn, noddiColors, NoddiIcon, webButtonStyling } from 'noddi-ui-common';

interface Props {
  isSelected: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  make: string | undefined;
  model: string | undefined;
  licensePlateNumber: string;
  price: string;
}

export const FleetCarSelectionButton = ({ isSelected, onClick, make, model, licensePlateNumber, price }: Props) => (
  <button
    onClick={onClick}
    className={cn(
      'flex items-center justify-between gap-2 border border-darkPurple px-3 py-1 text-start text-darkPurple',
      webButtonStyling,
      isSelected && 'border-purple bg-purple text-white'
    )}
  >
    <div className='flex items-center gap-2'>
      <NoddiIcon
        name={isSelected ? 'CheckedRectangle' : 'Rectangle'}
        color={isSelected ? noddiColors.white : noddiColors.darkPurple}
      />

      <div className='flex flex-col'>
        <span>
          {make} {model}
        </span>
        <span>{licensePlateNumber}</span>
      </div>
    </div>
    <span>{price}</span>
  </button>
);
